import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { noop } from 'lodash'
import Paper from 'material-ui/Paper'
import { Row, Col } from 'pui-react-grids'
import { handleSumbissionErrors } from '../form/errors'
import RegisterForm from '../common/RegisterForm'
import Spinner from '../common/Spinner'
import { register, fbMe } from '../api'
import { login } from '../actions'
// import Footer from '../common/Footer'

const generateRandomPassword = length =>
  Array.apply(null, { length })
    .map(_ => String.fromCharCode(97 + Math.floor(Math.random() * 26)))
    .join('')

const styles = {
  welcomeCol: {
    height: '100%',
  },
  successRegContainer: {
    padding: 10,
  },
}

class Register extends PureComponent {
  state = {
    userData: null,
  }

  handleRegistration = ({
    email,
    username,
    password,
    facebookAccessToken,
    facebookId,
    signUpWith,
  }) => {
    if (signUpWith === 'email') {
      // Normal registration flow
      return register({
        username,
        email,
        plainPassword: {
          first: password,
          second: password,
        },
      })
        .then(user => ({ user }))
        .catch(handleSumbissionErrors)
    } else if (signUpWith === 'facebook') {
      // I am a tired, sad men...
      const randomPassword = generateRandomPassword(10)
      return register({
        facebookAccessToken,
        facebookId,
        email,
        username,
        plainPassword: {
          first: randomPassword,
          second: randomPassword,
        },
      })
        .then(user => ({ user, facebookAccessToken }))
        .catch(handleSumbissionErrors)
    }
  }

  handleRegistrationSuccess = ({ user, facebookAccessToken }) => {
    if (facebookAccessToken) {
      this.props.login({ fb: true, accessToken: facebookAccessToken })
      this.setState({ userData: { ...user, fb: true } })
    } else {
      this.setState({ userData: user })
    }
  }

  render() {
    // <div style={{ minHeight: '100vh' }}>
    return (
      <div>
        <Row style={{ marginLeft: 0, marginRight: 0 }}>
          <Col lg={8} md={7} sm={6} />
          <Col lg={8} md={10} sm={12} style={styles.welcomeCol}>
            {!this.state.userData &&
              <div>
                <RegisterForm
                  onSubmit={this.handleRegistration}
                  onSubmitSuccess={this.handleRegistrationSuccess}
                />
              </div>}
            {this.state.userData &&
              <Paper style={styles.successRegContainer}>
                <p>
                  Benvenuto
                  {' '}
                  {this.state.userData.username}
                  {this.state.userData.fb
                    ? ` stai per essere loggato in Swapick...`
                    : `, controlla la casella email ${this.state.userData.email} per completare la registrazione.`}
                </p>
              </Paper>}
          </Col>
          <Col lg={8} md={7} sm={6} />
        </Row>
        {/* <div className="bottom"> */}
        {/* <Footer /> */}
        {/* </div> */}
      </div>
    )
  }
}

export default connect(undefined, {
  login,
})(Register)



// WEBPACK FOOTER //
// ./src/pages/Register.js